import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

export default createReactClass({
  displayName: 'Root',
  propTypes: {
    servicesCategories: PropTypes.array.isRequired,
    onChangeSelectedGenre: PropTypes.func.isRequired,
    selectedGenres: PropTypes.array,
    initialOpenGenre: PropTypes.object.isRequired,
    checkDisabled: PropTypes.bool,
  },
  getInitialState() {
    let showMoreObj = {};
    Object.keys(this.props.initialOpenGenre).forEach((serviceId) => {
      showMoreObj[serviceId] = false;
    });
    return {
      showMore: showMoreObj,
    };
  },
  changeShowMore(e) {
    const changeServiceId = e.target.getAttribute('data-value');
    let tmpShowMore = this.state.showMore;
    tmpShowMore[changeServiceId] = !tmpShowMore[changeServiceId];
    this.setState({
      showMore: tmpShowMore,
    });
  },
  render() {
    const onChangeSelectedGenre = this.props.onChangeSelectedGenre;
    const changeShowMore = this.changeShowMore;
    const selectedGenres = this.props.selectedGenres;
    const checkDisabled = this.props.checkDisabled;
    const showMore = this.state.showMore;
    const initialOpenGenre = this.props.initialOpenGenre;

    const servicesCategoriesBox = this.props.servicesCategories.map(
      (services_category) => {
        const isHobby = services_category.circle_type === 0;
        const isOshikatsu = services_category.circle_type === 10;

        if (isOshikatsu) {
          return (
            <div className="card border-0" key={services_category.id}>
              <div className="card-header bg-white p-3">
                <label className="d-flex justify-content-between align-items-center mb-0 position-relative">
                  <p className="mb-0 font-weight-bold p-0 line-height-2 pl-3 mb-0">
                    {services_category.name}
                  </p>
                  <input
                    type="checkbox"
                    name="category"
                    className="d-none checkbox__input"
                    onChange={onChangeSelectedGenre}
                    value={services_category.id}
                    checked={selectedGenres.includes(
                      String(services_category.id)
                    )}
                    disabled={
                      checkDisabled &&
                      !selectedGenres.includes(String(services_category.id))
                        ? 'disabled'
                        : ''
                    }
                  />
                  <span className="checkbox__lg" />
                </label>
              </div>
            </div>
          );
        } else {
          return (
            <div
              className="accordion"
              id="accordionExample"
              key={services_category.id}
            >
              <div className="card border-top-0 border-right-0 border-left-0 border-bottom rounded-0">
                <div
                  className="card-header bg-white p-3"
                  id={`#heading${services_category.id}`}
                >
                  <a
                    className="p-0 nav-link link--arrow line-height-2 cursor-pointer"
                    data-toggle="collapse"
                    data-target={`#collapse${services_category.id}`}
                    aria-expanded="false"
                    aria-controls={`collapse${services_category.id}`}
                  >
                    {services_category.name}
                  </a>
                </div>
              </div>

              <div
                id={`collapse${services_category.id}`}
                className={`collapse ${(() => {
                  if (initialOpenGenre[services_category.id]) {
                    return ' show';
                  } else {
                    return '';
                  }
                })()}`}
                aria-labelledby={`#heading${services_category.id}`}
                data-parent="#accordionExample"
              >
                <div className="card-body p-0">
                  <ul className="nav flex-column">
                    {services_category.categories.map((category) => {
                      if (category.services_category.is_primary) {
                        return (
                          <li
                            className="nav-item p-3 border-bottom"
                            key={category.id}
                          >
                            <label className="d-flex align-items-center mb-0 position-relative">
                              <p className="flex-grow-1 text-center mb-0">
                                {category.name}
                              </p>
                              <input
                                type="checkbox"
                                name="category"
                                id=""
                                className="d-none checkbox__input"
                                onChange={onChangeSelectedGenre}
                                value={category.id}
                                checked={
                                  selectedGenres.indexOf(
                                    String(category.id)
                                  ) !== -1
                                }
                                disabled={
                                  checkDisabled &&
                                  selectedGenres.indexOf(
                                    String(category.id)
                                  ) === -1
                                    ? 'disabled'
                                    : ''
                                }
                              />
                              <span className="checkbox__lg ml-auto" />
                            </label>
                          </li>
                        );
                      }
                    })}
                    {services_category.categories &&
                      !services_category.categories.every(
                        (category) => category.services_category.is_primary
                      ) && (
                        <li className="nav-item p-3 border-bottom">
                          <a
                            className="nav-link text-black-20 p-0 link--arrow -bottom line-height-2 pl-3 text-center"
                            onClick={changeShowMore}
                            data-value={services_category.id}
                          >
                            {showMore[services_category.id]
                              ? '閉じる'
                              : 'もっと見る'}
                          </a>
                        </li>
                      )}
                    {services_category.categories.map((category) => {
                      if (
                        showMore[services_category.id] &&
                        !category.services_category.is_primary
                      ) {
                        return (
                          <li
                            className="nav-item p-3 border-bottom"
                            key={category.id}
                          >
                            <label className="d-flex align-items-center mb-0 position-relative">
                              <p className="flex-grow-1 text-center mb-0">
                                {category.name}
                              </p>
                              <input
                                type="checkbox"
                                name="category"
                                className="d-none checkbox__input"
                                onChange={onChangeSelectedGenre}
                                value={category.id}
                                checked={selectedGenres.includes(
                                  String(category.id)
                                )}
                                disabled={
                                  checkDisabled &&
                                  !selectedGenres.includes(String(category.id))
                                    ? 'disabled'
                                    : ''
                                }
                              />
                              <span className="checkbox__lg" />
                            </label>
                          </li>
                        );
                      }
                    })}
                  </ul>
                </div>
              </div>
            </div>
          );
        }
      }
    );
    return <div>{servicesCategoriesBox}</div>;
  },
});
